<template>
    <div class="manage-container">
        <div :class="['manage-content']" :style="{ height: state.isMobile ? containerMobileHeight : containerHeight }">
            <slot></slot>
        </div>
    </div>
</template>
<script>

import { useTributeEditorStore } from '@/stores/tributeEditor';

export default {
    setup() {
        return {
            tributeEditor: useTributeEditorStore()
        }
    },
    inject: ['state'],
    computed: {
        containerHeight() {
            return this.tributeEditor.computedWorkspaceHeight;
        },
        containerMobileHeight() {
            return this.tributeEditor.computedMobileWorkspaceHeight;
        },
    },
};
</script>
<style lang="scss" scoped>
.manage-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: transform 0.8s;
    overflow: hidden;
    width: 100%;

    max-width: 100%;
    max-height: 100%;

    // max-width: calc(100% - 24px);
    padding: 10px 12px;
    padding-top: 0;
    border-radius: 8px;
    background-color: #f3f4f6;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
    @include mobile() {
        // margin-bottom: 60px;
        overscroll-behavior: contain;
    }
}

.manage-content {
    height: 100%;
    max-height: 100%;
    background: white;
    border-radius: 8px;
    padding: 8px;
    gap: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
    transition: height 0.8s;
    @include mobile() {
        position: relative;
        flex-direction: column-reverse;
        margin-top: 6px;
    }
}

.manage-content > div:first-child {
    height: 100%;
    max-height: 100%;
}

// @media (max-width: 600px) {
//     .manage-content {
//         height: 40vh;
//     }

//     .manage-content.expanded {
//         height: 75vh;
//     }
// }
</style>
